import { dealEventLogControllerGetDealEventSubjectsOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { useDealEventPeopleFilter } from '@dealstack/frontend/app/pages/Project/DealEventLog/useDealEventPeopleFilter.ts';

const page = (
	data:
		| { subjects?: { id: string; name?: string; email: string }[]; hasMore?: boolean }
		| undefined
) => ({
	people: data?.subjects ?? [],
	hasMore: !!data?.hasMore,
});

const toValue = ({ id }: { id?: string }) => id ?? '';

/**
 * The users the deal's team and access events are about, read from the events rather than from
 * the deal's current team: a revoked member is still named there.
 */
export const useDealEventSubjects = (dealId: string, enabled: boolean, selected?: string) =>
	useDealEventPeopleFilter({
		dealId,
		enabled,
		selected,
		queryOptions: dealEventLogControllerGetDealEventSubjectsOptions,
		page,
		toValue,
	});
